export function extractEmailsFromString(input: string): string[] {
  // Use a regular expression to split the string by commas or colons
  const emailArray = input.split(/[,;]+/);

  // Trim any extra whitespace from each email
  return emailArray.map((email) => email.trim()).filter((email) => email.length > 0);
}
